import React from 'react';
import { Alert, Button, Chip, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';

export default function AiReviewPanel({
  summary,
  error,
  count,
  reviewing,
  onApply,
  onClear,
}) {
  if (!summary && !error && count === 0 && !reviewing) return null;

  return (
    <Stack spacing={1} sx={{ mb: 1 }}>
      {error && <Alert severity="error">{error}</Alert>}
      {reviewing && <Alert severity="info">Reviewing worksheet...</Alert>}
      {(summary || count > 0) && (
        <Alert
          severity="info"
          action={
            count > 0 ? (
              <Stack direction="row" spacing={1}>
                <Button size="small" startIcon={<CheckCircleIcon />} onClick={onApply}>
                  Apply AI suggestions
                </Button>
                <Button size="small" color="inherit" startIcon={<ClearIcon />} onClick={onClear}>
                  Clear
                </Button>
              </Stack>
            ) : null
          }
        >
          <Stack spacing={0.5}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="body2" fontWeight={700}>AI worksheet review</Typography>
              {count > 0 && <Chip size="small" label={`${count} suggestion${count === 1 ? '' : 's'}`} />}
            </Stack>
            {summary && <Typography variant="body2">{summary}</Typography>}
          </Stack>
        </Alert>
      )}
    </Stack>
  );
}

